import React from 'react';
import { withRouter, Switch, Route } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Layout from './Layout';
import Home from '../Home/Index';
import Register from '../Home/Register';
import AboutUs from '../Home/Aboutus';
import ContactUs from '../Home/Contactus';
import Product from '../Home/Product';
import Team from '../Home/Team';
import CommonClass from '../../js/common';
import Invite from '../Home/Invite';

const App = ({ location }) => {
  const currentKey = location.pathname.split('/')[1] || '/'
  CommonClass.componentPage = currentKey;
  const timeout = { enter: 0, exit: 1000 }
  return (
    <Layout>
      <TransitionGroup>
        <CSSTransition key={currentKey} timeout={timeout} classNames="fade" appear>
          <section>
            <Switch location={location}>
              <Route path="/" exact component={Home} componentName="home" />
              <Route path="/home" exact component={Home} componentName="home" />
              <Route path="/register" component={Register} componentName="register" />
              <Route path="/aboutus" component={AboutUs} componentName="aboutus" />
              <Route path="/contactus" component={ContactUs} componentName="contactus" />
              <Route path="/products" component={Product} componentName={currentKey} />
              <Route path="/team" component={Team} componentName="team" />
              <Route path="/invite" component={Invite} componentName="invite" />
            </Switch>
          </section>
        </CSSTransition>
      </TransitionGroup>
    </Layout>
  )
}

export default withRouter(App)


// WEBPACK FOOTER //
// src/components/Common/App.js